import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { vendorRepository } from '../data-access/repositories/VendorRepository'

const base = ['vendor']

export const vendorQueryConfig = {
  getVendors: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => vendorRepository.getVendors(params),
  }),
  getVendor: (id: number) => ({
    queryKey: buildQueryKey([...base, 'detail', id]),
    queryFn: () => vendorRepository.getVendor(id),
  }),
  getVendorDocuments: (vendorId: number, params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'documents', vendorId, params]),
    queryFn: () => vendorRepository.getVendorDocuments(vendorId, params),
  }),
}
